import { Country } from 'api/countries/getCountriesList'
import { useEffect, useState } from 'react'

type SearchableKey = Pick<Country, 'name' | 'countryCode'>
const searchParam: (keyof SearchableKey)[] = ['name', 'countryCode']

export function useSearchableCountrylist(countryList: Country[]) {
  const [searchText, setSearchText] = useState('')
  const [filteredCountryList, setFilteredCountryList] = useState(countryList)

  const search = (text: string) => {
    if (text === '') {
      setFilteredCountryList(countryList)
    } else {
      setFilteredCountryList(filteredList())
    }
  }

  const filteredList = () => {
    return countryList.filter((item: Country) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(searchText.toLowerCase()) > -1
        )
      })
    })
  }

  useEffect(() => {
    search(searchText)
  }, [searchText])

  return { filteredCountryList, searchText, setSearchText }
}
